import React from 'react';
import './InterviewQuestionItem.css';

const InterviewQuestionItem = ({ question, index }) => {

  return (

    <li className="accordion-item">
      <span className="accordion-title">
        <span>{index}. {question.question}</span>

        {question.iscode && (
          <span className="right-one">
            <i className="bx bx-code-block bg-transparent"></i>
          </span>
        )}

        <span className={`right level-tag ${question.levelname.toLowerCase()}`}>
          {question.levelname}
        </span>
      </span>

      <div class="accordion-content show">
        <p className="answer-text"
          dangerouslySetInnerHTML={{ __html: question.answer }} />
      </div>
    </li>
  );
};

export default InterviewQuestionItem;